module.exports = __webpack_public_path__ + "img/logo-white.50b641b2.svg";